import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, inject } from "@angular/core";
import { IMenuOption } from "@tylertech/forge";
import { IChatQueueItem } from "@tylertech/tyler-api-types";
import { WINDOW } from "@tylertech/shared-module";
import { ChatService } from "../../../services";

@Component({
    selector: "support-chat",
    templateUrl: "./supportChat.tmpl.html",
    styleUrls: ["./supportChat.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SupportChatComponent implements OnInit
{
    private readonly window = inject<Window>(WINDOW);
    private readonly changeDetectorRef = inject(ChangeDetectorRef);
    private readonly $chatService = inject(ChatService);

    protected initializing?: Promise<void>;
    chatMenuItems: Array<IMenuOption>;
    initialized: boolean;
    chatQueueList: Array<IChatQueueItem> = [];
    isOpen: boolean;

    get isMenu(): boolean
    {
        return this.chatQueueList?.length > 1;
    }

    get singleChatText(): string
    {
        return this.chatQueueList[0]?.QueueText;
    }

    ngOnInit(): void
    {
        this.initializing = this.$chatService.GetChatQueueItems()
            .then((r: Array<IChatQueueItem>) =>
            {
                if (r)
                {
                    this.chatQueueList = r;
                    this.populateChatList();
                }
            })
            .finally(() =>
            {
                this.initializing = undefined;
            });
    }

    menuOpened(e): void
    {
        e.target.activateFirstOption();
    }

    openChat($event: Event): void
    {
        const chatQueue: IMenuOption = this.isMenu
            ? ($event as CustomEvent<IMenuOption>).detail
            : undefined;

        let value = null;
        if (chatQueue)
        {
            value = chatQueue.value;
        }
        else
        {
            if (this.chatQueueList?.length === 1)
            {
                value = this.chatQueueList[0].Tag;
            }
        }

        if (value)
        {
            this.$chatService.GetChatUrl(value)
                .then(r =>
                {
                    if (r) {
                        this.window.open(r, "", "width=630,height=715,status=no,scrollbars=no,toolbar=no");
                    }
                });
        }
    }

    private populateChatList(): void
    {
        if (this.chatQueueList)
        {
            this.chatMenuItems = [];
            const subMenus: [string, IMenuOption] = [null, null];
            this.chatQueueList.forEach(
                item =>
                {
                    const menuItem: IMenuOption = {
                        value: item.Tag,
                        label: item.QueueText,
                    };
                    if (item.MenuPath)
                    {
                        const newMenuItem = addChatSubmenu(item.MenuPath, subMenus, menuItem);
                        if (newMenuItem != null)
                        {
                            this.chatMenuItems.push(newMenuItem);
                        }
                    }
                    else
                    {
                        this.chatMenuItems.push(menuItem);
                    }
                });

            this.initialized = true;
            this.changeDetectorRef.markForCheck();
        }

        function addChatSubmenu(
            menuPath: string,
            subMenus: [string, IMenuOption],
            newMenuItem: IMenuOption
        ): IMenuOption
        {
            if (!menuPath)
            {
                return newMenuItem;
            }

            if (subMenus[menuPath])
            {
                subMenus[menuPath].options.push(newMenuItem);
                return null;
            }

            const menuName = menuPath.split("/")
                .pop();
            const subMenuItem: IMenuOption = {
                value: menuName,
                label: menuName,
                options: [newMenuItem],
            };
            subMenus[menuPath] = subMenuItem;

            const lastSlashIndex = menuPath.lastIndexOf("/");
            return addChatSubmenu(
                menuPath.substring(0, lastSlashIndex !== -1 ? lastSlashIndex : 0),
                subMenus,
                subMenuItem);
        }
    }
}
